import React from 'react'

const UserHomePage = () => {
    return <div>Hola soy el User Home PAGE</div>
}

export default UserHomePage
